import { ApplicationConfig, provideBrowserGlobalErrorListeners, isDevMode, provideAppInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { apiAuthInterceptor } from './core/api-auth.interceptor';
import { AUDIO_TRANSCRIBER } from './core/audio.service';
import { HttpAudioTranscriber } from './core/audio-transcriber';
import { AppConfigService, VOICE_ENABLED } from './core/app-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiAuthInterceptor])),
    provideAnimations(),
    provideToastr({ positionClass: 'toast-top-right', timeOut: 6000, closeButton: true, preventDuplicates: true }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    { provide: AUDIO_TRANSCRIBER, useClass: HttpAudioTranscriber },
    { provide: VOICE_ENABLED, useFactory: (c: AppConfigService) => c.enableVoice, deps: [AppConfigService] },
    provideAppInitializer(() => inject(AppConfigService).load()),
  ],
};
